<template>
  <a @click="scrollTop" v-show="visible" class="bottom-right">
    <fa :icon="faChevronUp"/>
  </a>
</template>

<script>
import Fa from 'vue-fa'
import { faChevronUp } from '@fortawesome/free-solid-svg-icons'

export default {
  name: 'ScrollToTop',
  components: {Fa},
  data () {
    return {
      visible: false,
      faChevronUp
    }
  },
  methods: {
    scrollTop () {
      this.intervalId = setInterval(() => {
        if (window.pageYOffset === 0) {
          clearInterval(this.intervalId)
        }
        window.scroll(0, window.pageYOffset - 50)
      }, 20)
    },
    scrollListener (e) {
      this.visible = window.scrollY > 150
    }
  },
  mounted () {
    window.addEventListener('scroll', this.scrollListener)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.scrollListener)
  }
}
</script>

<style scoped lang="scss">
  .bottom-right {
    position: fixed;
    border-radius: 10px;
    background: white;
    padding: 20px;
    bottom: 20px;
    right: 20px;
    z-index: 1;
    cursor: pointer;
    &:hover {
      transition: .5s;
      color: $primary!important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/front/components/common/ScrollToTop.vue